import { ICardToObSettings } from '../reducers/create-card-to-ob-settings';

export const cardToObSettings = (payload: ICardToObSettings) => {
    return {
        type: 'CREATE_CARD_TO_OB_SETTINGS',
        payload,
    }
}